import {tableFeatures} from '@tanstack/react-table';

export const dataTableFeatures = tableFeatures({});

export type DataTableFeatures = typeof dataTableFeatures;
